module.exports = __webpack_public_path__ + "static/media/empty.4ef692b7.svg";